module.exports = __webpack_public_path__ + "static/media/bunnypancake.b7efd7f9.svg";